// extracted by mini-css-extract-plugin
module.exports = {"page":"FastTrack_page__1I-d5","button":"FastTrack_button__28qY9"};